// 漫画数据（mock）
// 封面图统一为暖色调动漫插画风格，竖版 600x800

export type Comic = {
  id: string;
  title: string;
  cover: string;
  categories: string[];
  tags: string[];
  author: string;
  status: '连载中' | '已完结' | '暂停更新';
  updateDay: string;
  totalChapters: number;
  latestChapter: string;
  updateProgress: number; // 同步更新进度 0-100
  translateProgress: number; // 汉化进度 0-100
  rating: number;
  views: string;
  hot: number;
  description: string;
};

export const categories = ['全部', '热血', '恋爱', '奇幻', '悬疑', '校园', '搞笑', '科幻', '冒险'];

export const comics: Comic[] = [
  {
    id: 'xi-feng-zhan',
    title: '西风斩',
    cover: 'https://readdy.ai/api/search-image?query=dynamic%20shonen%20manga%20cover%20art%20of%20a%20young%20swordsman%20with%20a%20blazing%20katana%2C%20emerald%20green%20and%20crimson%20energy%20swirling%2C%20dramatic%20action%20pose%2C%20warm%20sunset%20sky%20background%2C%20clean%20ink%20lines%2C%20vivid%20semi%20realistic%20anime%20style%2C%20high%20contrast%20lighting%2C%20heroic%20and%20powerful%20atmosphere%2C%20bold%20character%20design&width=600&height=800&seq=comic-01&orientation=portrait',
    categories: ['热血', '冒险'],
    tags: ['战斗', '羁绊', '成长'],
    author: '苍梧漫社',
    status: '连载中',
    updateDay: '每周五',
    totalChapters: 128,
    latestChapter: '第128话 · 破晓之刃',
    updateProgress: 96,
    translateProgress: 92,
    rating: 4.9,
    views: '1260万',
    hot: 98,
    description: '少年剑客白夜背负家族诅咒踏上斩妖之旅，在一次次生死对决中觉醒沉睡的力量，与同伴并肩，只为守住心中那抹不曾熄灭的晨光。',
  },
  {
    id: 'zhi-shang-lian-ai',
    title: '指尖的恋爱信号',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20slice%20of%20life%20manga%20cover%20art%20of%20a%20smiling%20high%20school%20couple%20standing%20close%20under%20cherry%20blossoms%2C%20soft%20warm%20pink%20and%20golden%20glow%2C%20gently%20holding%20fingertips%2C%20gentle%20breeze%20with%20falling%20petals%2C%20tender%20clean%20anime%20illustration%2C%20dreamy%20warm%20color%20palette%2C%20soft%20cinematic%20light%2C%20youthful%20and%20heartwarming%20mood&width=600&height=800&seq=comic-02&orientation=portrait',
    categories: ['恋爱', '校园'],
    tags: ['青春', '暗恋', '治愈'],
    author: '拾光工作室',
    status: '连载中',
    updateDay: '每周三',
    totalChapters: 86,
    latestChapter: '第86话 · 雨后的告白',
    updateProgress: 94,
    translateProgress: 97,
    rating: 4.8,
    views: '880万',
    hot: 91,
    description: '沉默寡言的优等生与开朗的邻座女孩，因为一封被误送的情书，开始了一段关于勇气、误会与心动的青春故事。',
  },
  {
    id: 'mo-yu-shen-gong',
    title: '魔狱神宫',
    cover: 'https://readdy.ai/api/search-image?query=fantasy%20magic%20manga%20cover%20art%20of%20a%20robed%20mage%20casting%20a%20spell%20inside%20an%20ancient%20crimson%20palace%2C%20floating%20golden%20runes%20and%20arcane%20light%2C%20majestic%20pillars%20and%20stained%20glass%2C%20warm%20amber%20and%20deep%20red%20glow%2C%20epic%20high%20fantasy%20atmosphere%2C%20intricate%20detail%2C%20rich%20semi%20realistic%20anime%20style%2C%20mysterious%20and%20grand%20mood&width=600&height=800&seq=comic-03&orientation=portrait',
    categories: ['奇幻', '冒险'],
    tags: ['魔法', '秘境', '权谋'],
    author: '星澜漫动',
    status: '连载中',
    updateDay: '每周一',
    totalChapters: 203,
    latestChapter: '第203话 · 王座之下',
    updateProgress: 98,
    translateProgress: 89,
    rating: 4.9,
    views: '1540万',
    hot: 99,
    description: '凡人之躯的药师少年意外闯入被封印的魔狱神宫，在重重考验中习得禁忌魔法，逐步揭开这座神宫背后尘封千年的王权秘密。',
  },
  {
    id: 'jie-du-zhi-shu',
    title: '解读之书',
    cover: 'https://readdy.ai/api/search-image?query=dark%20mystery%20detective%20manga%20cover%20art%20of%20a%20young%20female%20detective%20holding%20an%20old%20leather%20book%20in%20a%20moody%20noir%20study%2C%20candlelight%20and%20long%20shadows%2C%20deep%20browns%20and%20muted%20teal%20tones%2C%20whisps%20of%20smoke%2C%20intriguing%20conspiracy%20posters%20on%20the%20wall%2C%20semi%20realistic%20anime%20illustration%2C%20tense%20atmospheric%20lighting%2C%20smart%20and%20suspenseful%20mood&width=600&height=800&seq=comic-04&orientation=portrait',
    categories: ['悬疑'],
    tags: ['推理', '谜案', '反转'],
    author: '墨影社',
    status: '连载中',
    updateDay: '每周六',
    totalChapters: 64,
    latestChapter: '第64话 · 第十三页',
    updateProgress: 88,
    translateProgress: 85,
    rating: 4.7,
    views: '620万',
    hot: 85,
    description: '一本会自行改写内容的神秘书籍，把年轻侦探卷入一连串不可能犯罪。每一页真相背后，都藏着更深的陷阱。',
  },
  {
    id: 'chun-feng-lian-meng',
    title: '春风恋盟',
    cover: 'https://readdy.ai/api/search-image?query=school%20comedy%20manga%20cover%20art%20of%20a%20cheerful%20group%20of%20high%20school%20students%20laughing%20in%20a%20sunny%20classroom%2C%20golden%20afternoon%20light%2C%20warm%20green%20and%20cream%20tones%2C%20playful%20energetic%20pose%2C%20bright%20clean%20anime%20illustration%2C%20youthful%20excitement%2C%20sunshine%20streaming%20through%20windows%2C%20vibrant%20and%20fun%20atmosphere%2C%20rounded%20friendly%20character%20design&width=600&height=800&seq=comic-05&orientation=portrait',
    categories: ['校园', '搞笑'],
    tags: ['社团', '日常', '欢乐'],
    author: '晴空绘',
    status: '连载中',
    updateDay: '每周二',
    totalChapters: 152,
    latestChapter: '第152话 · 社团大作战',
    updateProgress: 95,
    translateProgress: 93,
    rating: 4.6,
    views: '740万',
    hot: 88,
    description: '濒临废部的“春风社”迎来一群性格迥异的新人，从办社刊到筹办校庆，每天上演哭笑不得的高中日常。',
  },
  {
    id: 'xing-jie-xian-feng',
    title: '星界先锋',
    cover: 'https://readdy.ai/api/search-image?query=mecha%20sci%20fi%20manga%20cover%20art%20of%20a%20pilot%20standing%20before%20a%20giant%20war%20mech%20in%20a%20neon%20space%20harbor%2C%20warm%20orange%20and%20steel%20glow%2C%20starry%20void%20background%2C%20sleek%20mechanical%20details%2C%20dramatic%20cinematic%20light%2C%20semi%20realistic%20anime%20illustration%2C%20epic%20scale%2C%20futuristic%20and%20heroic%20mood&width=600&height=800&seq=comic-06&orientation=portrait',
    categories: ['科幻', '热血'],
    tags: ['机甲', '星际', '热血'],
    author: '轨道引力',
    status: '连载中',
    updateDay: '每周四',
    totalChapters: 97,
    latestChapter: '第97话 · 跃迁边界',
    updateProgress: 90,
    translateProgress: 86,
    rating: 4.8,
    views: '980万',
    hot: 93,
    description: '人类在群星间扩张之际，少年机师驾驶着唯一的原型机“星界先锋”，守护边境航线的和平与希望。',
  },
  {
    id: 'wang-zhi-gang',
    title: '王座之下',
    cover: 'https://readdy.ai/api/search-image?query=adventure%20fantasy%20manga%20cover%20art%20of%20a%20young%20king%20climbing%20an%20ancient%20mountain%20staircase%20toward%20a%20golden%20throne%20on%20the%20summit%2C%20morning%20mist%20and%20warm%20sunrise%20light%2C%20emerald%20valleys%20below%2C%20epic%20proportion%2C%20rich%20detail%2C%20semi%20realistic%20anime%20illustration%2C%20adventurous%20and%20uplifting%20atmosphere%2C%20heroic%20silhouette&width=600&height=800&seq=comic-07&orientation=portrait',
    categories: ['冒险', '奇幻'],
    tags: ['王权', '试炼', '史诗'],
    author: '苍梧漫社',
    status: '连载中',
    updateDay: '每周日',
    totalChapters: 74,
    latestChapter: '第74话 · 山巅的抉择',
    updateProgress: 84,
    translateProgress: 79,
    rating: 4.5,
    views: '410万',
    hot: 74,
    description: '没有继承权的流放王子，为证明自己而踏上登顶圣山的试炼之路，沿途结识的盟友与敌人，将决定王座的归属。',
  },
  {
    id: 'dou-lei-gu',
    title: '斗擂谷',
    cover: 'https://readdy.ai/api/search-image?query=tournament%20action%20manga%20cover%20art%20of%20two%20martial%20artists%20facing%20off%20in%20a%20huge%20ancient%20arena%20at%20dusk%2C%20dramatic%20warm%20ember%20and%20gold%20light%2C%20dust%20and%20energy%20kicked%20up%2C%20crowd%20silhouettes%2C%20intense%20duel%20moment%2C%20dynamic%20brushwork%2C%20semi%20realistic%20anime%20illustration%2C%20powerful%20and%20electrifying%20atmosphere&width=600&height=800&seq=comic-08&orientation=portrait',
    categories: ['热血', '搞笑'],
    tags: ['格斗', '竞技', '成长'],
    author: '燃点漫创',
    status: '连载中',
    updateDay: '每周四',
    totalChapters: 188,
    latestChapter: '第188话 · 擂主之争',
    updateProgress: 97,
    translateProgress: 95,
    rating: 4.9,
    views: '1320万',
    hot: 96,
    description: '在山中长大的少年阿擂，误打误撞闯入天下闻名的格斗大会“斗擂谷”，从此一路过关斩将，向最强擂主发起挑战。',
  },
  {
    id: 'qing-zhi-mi-ji',
    title: '情之迷记',
    cover: 'https://readdy.ai/api/search-image?query=heartwarming%20childhood%20friends%20romance%20manga%20cover%20art%20of%20two%20young%20adults%20sharing%20an%20umbrella%20on%20a%20rainy%20street%20at%20night%2C%20city%20lights%20bokeh%2C%20warm%20gold%20and%20soft%20coral%20tones%2C%20tender%20close%20moment%2C%20semi%20realistic%20anime%20illustration%2C%20soft%20reflective%20wet%20ground%2C%20intimate%20and%20melancholic%20romantic%20mood&width=600&height=800&seq=comic-09&orientation=portrait',
    categories: ['恋爱'],
    tags: ['青梅竹马', '都市', '温情'],
    author: '拾光工作室',
    status: '连载中',
    updateDay: '每周三',
    totalChapters: 53,
    latestChapter: '第53话 · 同一把伞下',
    updateProgress: 81,
    translateProgress: 90,
    rating: 4.7,
    views: '350万',
    hot: 71,
    description: '从小一起长大的两人，在各自追逐梦想多年后于都市重逢。那些没说出口的喜欢，都藏在一把小小的伞下。',
  },
  {
    id: 'wu-xiao-zhi-hun',
    title: '武魂之烬',
    cover: 'https://readdy.ai/api/search-image?query=epic%20battle%20manga%20cover%20art%20of%20a%20determined%20young%20warrior%20wreathed%20in%20flames%20raising%20a%20spear%20against%20a%20huge%20shadow%20beast%2C%20embers%20and%20smoke%2C%20crimson%20and%20charcoal%20palette%2C%20dramatic%20low%20angle%2C%20intense%20semi%20realistic%20anime%20illustration%2C%20raw%20energy%2C%20high%20stakes%20battle%20atmosphere&width=600&height=800&seq=comic-10&orientation=portrait',
    categories: ['热血', '奇幻'],
    tags: ['修炼', '宿命', '燃'],
    author: '燃点漫创',
    status: '连载中',
    updateDay: '每周一',
    totalChapters: 240,
    latestChapter: '第240话 · 魂烬重生',
    updateProgress: 99,
    translateProgress: 91,
    rating: 4.8,
    views: '1680万',
    hot: 97,
    description: '失去武魂的少年，在灰烬中觉醒足以焚尽宿命的烈焰之力，踏上夺回一切的征途。',
  },
  {
    id: 'mi-gong-shou-wei',
    title: '迷宫守卫',
    cover: 'https://readdy.ai/api/search-image?query=isekai%20dungeon%20manga%20cover%20art%20of%20an%20armored%20guardian%20standing%20before%20a%20glowing%20ancient%20dungeon%20gate%20deep%20underground%2C%20floating%20crystal%20lights%2C%20warm%20teal%20and%20gold%20glow%2C%20mossy%20stone%20architecture%2C%20semi%20realistic%20anime%20illustration%2C%20mysterious%20and%20vast%2C%20fantasy%20adventure%20atmosphere%2C%20heroic%20stance&width=600&height=800&seq=comic-11&orientation=portrait',
    categories: ['奇幻', '冒险'],
    tags: ['异世界', '迷宫', '守护'],
    author: '星澜漫动',
    status: '已完结',
    updateDay: '—',
    totalChapters: 168,
    latestChapter: '已完结 · 第168话',
    updateProgress: 100,
    translateProgress: 100,
    rating: 4.6,
    views: '790万',
    hot: 68,
    description: '被召唤到异世界的守门人少年，负责守护一座藏有世界秘密的古老迷宫，在一次次入侵中守护身后的和平。',
  },
  {
    id: 'xin-li-ling-yu',
    title: '心理灵域',
    cover: 'https://readdy.ai/api/search-image?query=psychological%20thriller%20manga%20cover%20art%20of%20a%20young%20psychologist%20with%20eyes%20partially%20hidden%20by%20shadow%20sitting%20in%20a%20dim%20consulting%20room%2C%20tangled%20red%20threads%20floating%20around%2C%20deep%20crimson%20and%20grey%20tones%2C%20uneasy%20ambiguous%20composition%2C%20semi%20realistic%20anime%20illustration%2C%20tense%20claustrophobic%20lighting%2C%20mind%20bending%20and%20disturbing%20mood&width=600&height=800&seq=comic-12&orientation=portrait',
    categories: ['悬疑', '科幻'],
    tags: ['心理', '烧脑', '反转'],
    author: '墨影社',
    status: '连载中',
    updateDay: '每周六',
    totalChapters: 45,
    latestChapter: '第45话 · 回响',
    updateProgress: 76,
    translateProgress: 72,
    rating: 4.7,
    views: '290万',
    hot: 66,
    description: '能够读取他人内心创伤的心理医生，在一次治疗中发现自己也被卷入了某人的潜意识迷宫，真相与幻觉逐渐难以分辨。',
  },
];

export const updateProgressColors = ['primary', 'accent', 'secondary'] as const;

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}